<template>
  <VTextField
    :label="label"
    :value="value"
    :required="required || false"
    :disabled="disabled"
    :persistent-hint="!!info"
    :hint="info"
    :rules="required ? isRequired : []"
    @input="$emit('change', {val: $event, name: name})"
  />
</template>
<script>
  import defaultProps from './props.js'
  export default {
    props: [...defaultProps.default],
    data () {
      return {
        isRequired: [
          (value) => {
            if (value?.length > 0) return true
            return `${this.label || this.name} ist erforderlich.`
          },
        ],
      }
    },
  }
</script>
